var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFolderbadgeplus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 2.285 41.309 28.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "sf-notes-folder-badge-plus-cut0",
    maskUnits: "userSpaceOnUse",
    x: -100,
    y: -100,
    width: 300,
    height: 300
  }, /*#__PURE__*/React.createElement("rect", {
    x: -100,
    y: -100,
    width: 300,
    height: 300,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.437 20.313C38.965 20.313 43.594 15.684 43.594 10.156C43.594 4.59 39.004 0 33.437 0C27.852 0 23.281 4.59 23.281 10.156C23.281 15.742 27.852 20.313 33.437 20.313Z",
    fill: "#000"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "sf-notes-folder-badge-plus-cut1",
    maskUnits: "userSpaceOnUse",
    x: -100,
    y: -100,
    width: 300,
    height: 300
  }, /*#__PURE__*/React.createElement("rect", {
    x: -100,
    y: -100,
    width: 300,
    height: 300,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.437 15.059C32.812 15.059 32.422 14.649 32.422 14.043L32.422 11.172L29.551 11.172C28.945 11.172 28.535 10.762 28.535 10.156C28.535 9.551 28.945 9.141 29.551 9.141L32.422 9.141L32.422 6.27C32.422 5.664 32.812 5.254 33.437 5.254C34.043 5.254 34.453 5.664 34.453 6.27L34.453 9.141L37.324 9.141C37.93 9.141 38.32 9.551 38.32 10.156C38.32 10.762 37.93 11.172 37.324 11.172L34.453 11.172L34.453 14.043C34.453 14.649 34.043 15.059 33.437 15.059Z",
    fill: "#000"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#sf-notes-folder-badge-plus-cut1)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#sf-notes-folder-badge-plus-cut0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.98 31.016L30.605 31.016C33.379 31.016 35.019 29.375 35.019 26.094L35.019 10.391C35.019 7.109 33.359 5.488 30.039 5.488L15.41 5.488C14.453 5.488 13.828 5.215 13.086 4.609L12.109 3.828C11.094 2.988 10.254 2.695 8.77 2.695L4.395 2.695C1.641 2.695 0 4.297 0 7.559L0 26.094C0 29.375 1.66 31.016 4.98 31.016ZM5.02 28.184C3.613 28.184 2.812 27.441 2.812 25.957L2.812 7.695C2.812 6.25 3.594 5.508 5 5.508L8.027 5.508C8.984 5.508 9.609 5.781 10.352 6.387L11.328 7.168C12.324 7.988 13.184 8.301 14.668 8.301L30 8.301C31.406 8.301 32.207 9.063 32.207 10.547L32.207 25.977C32.207 27.441 31.406 28.184 30 28.184ZM4.902 13.262L30.117 13.262L30.117 12.149C30.117 11.211 29.668 10.801 28.75 10.801L6.27 10.801C5.371 10.801 4.902 11.211 4.902 12.149Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M33.437 18.027C37.695 18.027 41.309 14.453 41.309 10.156C41.309 5.84 37.754 2.285 33.437 2.285C29.121 2.285 25.547 5.84 25.547 10.156C25.547 14.492 29.121 18.027 33.437 18.027Z",
    fill: "currentColor"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderbadgeplus);
export default __webpack_public_path__ + "static/media/folder.badge.plus.d7b7cef2ce96a48dcbbaa1821be4bc1e.svg";
export { ForwardRef as ReactComponent };